import { API_URL } from "@/lib/config";
import { getAccessTokenWithRetry } from "@/lib/auth-token";

/**
 * Triggers coworker responses via the API after sending a message.
 * Fire-and-forget — errors are logged but don't affect the sender.
 */
export async function triggerCoworkerResponse(params: {
  getAccessToken: () => Promise<string | null>;
  channelId: string;
  messageId: string;
  content?: string;
  mentionIds?: string[];
}): Promise<void> {
  try {
    const token = await getAccessTokenWithRetry(params.getAccessToken, {
      maxWaitMs: 2000,
      intervalMs: 200,
    });
    if (!token) return;

    await fetch(`${API_URL}/api/coworker/respond`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        channel_id: params.channelId,
        message_id: params.messageId,
        ...(params.content ? { content: params.content } : {}),
        ...(params.mentionIds ? { mention_ids: params.mentionIds } : {}),
      }),
    });
  } catch {
    // Fire-and-forget — LISTEN/NOTIFY + polling are fallbacks
  }
}
